import { useRef, useState, useEffect } from 'react'
import { useWindowSize } from './use-window'

export function useYpos() {
	const ref = useRef()
	const [ start, setStart ] = useState( 0 )
	const { height } = useWindowSize()

	const calculateStart = () => {
		if ( ref.current ) {
			// @ts-ignore
			setStart( Math.max( ref.current.offsetTop - height, 1 ) )
		}
	}

	useEffect( calculateStart, [ ref, height ] )

	// Recalculate when the section becomes visible (in the mean time, the
	// position might have shifted due to lazy loading images)
	useEffect( () => {
		if ( ref.current ) {
			const io = new IntersectionObserver( ( [ section ] ) => {
				section.isIntersecting && calculateStart()
			})
			io.observe( ref.current )
			return () => io.disconnect()
		}
	}, [ height ] )

	const stop = ( start ? start + height * 2 : 0 )
	return { ref, start, stop }
}
